/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ManagerDispositionMainViewQueryRendererViewerQueryVariables = {
    startdate?: string | null | undefined;
    enddate?: string | null | undefined;
    lang: string;
    prefixes?: Array<string | null> | null | undefined;
};
export type ManagerDispositionMainViewQueryRendererViewerQueryResponse = {
    readonly viewer: {
        readonly userId: string;
    } | null;
    readonly holidayList: {
        readonly holidays: ReadonlyArray<{
            readonly date: string | null;
            readonly occasion: string | null;
        } | null> | null;
    } | null;
    readonly translationList: {
        readonly translations: ReadonlyArray<{
            readonly component: string | null;
            readonly text: string | null;
        } | null> | null;
    } | null;
};
export type ManagerDispositionMainViewQueryRendererViewerQuery = {
    readonly response: ManagerDispositionMainViewQueryRendererViewerQueryResponse;
    readonly variables: ManagerDispositionMainViewQueryRendererViewerQueryVariables;
};



/*
query ManagerDispositionMainViewQueryRendererViewerQuery(
  $startdate: String
  $enddate: String
  $lang: String!
  $prefixes: [String]
) {
  viewer {
    userId
  }
  holidayList(startdate: $startdate, enddate: $enddate) {
    holidays {
      date
      occasion
    }
  }
  translationList(lang: $lang, prefixes: $prefixes) {
    translations {
      component
      text
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enddate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prefixes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startdate"
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enddate",
        "variableName": "enddate"
      },
      {
        "kind": "Variable",
        "name": "startdate",
        "variableName": "startdate"
      }
    ],
    "concreteType": "HolidayList",
    "kind": "LinkedField",
    "name": "holidayList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Holiday",
        "kind": "LinkedField",
        "name": "holidays",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occasion",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "lang",
        "variableName": "lang"
      },
      {
        "kind": "Variable",
        "name": "prefixes",
        "variableName": "prefixes"
      }
    ],
    "concreteType": "TranslationList",
    "kind": "LinkedField",
    "name": "translationList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Translation",
        "kind": "LinkedField",
        "name": "translations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "component",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ManagerDispositionMainViewQueryRendererViewerQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ManagerDispositionMainViewQueryRendererViewerQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "042777c3244520179aa025ac352b0988",
    "id": null,
    "metadata": {},
    "name": "ManagerDispositionMainViewQueryRendererViewerQuery",
    "operationKind": "query",
    "text": "query ManagerDispositionMainViewQueryRendererViewerQuery(\n  $startdate: String\n  $enddate: String\n  $lang: String!\n  $prefixes: [String]\n) {\n  viewer {\n    userId\n  }\n  holidayList(startdate: $startdate, enddate: $enddate) {\n    holidays {\n      date\n      occasion\n    }\n  }\n  translationList(lang: $lang, prefixes: $prefixes) {\n    translations {\n      component\n      text\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '95798aa230f332053ce8ff2292fb0f89';
export default node;
